module.exports = __webpack_public_path__ + "static/media/view student assignment.6703cab5.svg";